<div [id]="id" [class]="class">
  <ng-container *ngFor="let button of buttonOptions; let i = index">
    <button
      [id]="id + '-' + button.name"
      (click)="onButtonClick(button.value)"
      class="inline-flex justify-around items-center gap-2"
      [class.selected-option]="values.includes(button.value)"
    >
      <span
        *ngIf="values.includes(button.value)"
        class="material-symbols-rounded icon-size"
      >
        {{ materialSymbol.check }}
      </span>
      <span
        *ngIf="!values.includes(button.value) && button.iconName"
        class="material-symbols-rounded icon-size"
      >
        {{ button.iconName }}
      </span>
      <span>{{ button.label }}</span>
    </button>
  </ng-container>
</div>
